import React from "react";
import PageShell from "@/components/PageShell";
import Hero from "@/components/sections/Hero";
import Ticker from "@/components/sections/Ticker";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Testimonials from "@/components/sections/Testimonials";
import CTASection from "@/components/CTASection";

export default function Home() {
    return (
        <PageShell>
            <div data-testid="home-page">
                <Hero />
                <Ticker />
                <About />
                <Services />
                <Testimonials />
                <CTASection />
            </div>
        </PageShell>
    );
}
